// Gold trust seal. Wording is deliberately compliance-safe: the third-party lab (Janoshik) is not
// Australian and no human trials are claimed — see PRD. Edit LINE_1 / LINE_2 to change the copy.
const LINE_1 = "Australian Owned";
const LINE_2 = "Independently Tested";

export function TrustSeal({ compact = false, className = "" }) {
  return (
    <div
      data-testid="trust-seal"
      className={`inline-flex items-center gap-2.5 border border-[#C9A227]/45 bg-[#C9A227]/[0.07] px-3 ${compact ? "py-1.5" : "py-2"} rounded-full backdrop-blur-sm ${className}`}
      style={{ boxShadow: "0 0 18px rgba(201,162,39,0.18), inset 0 0 12px rgba(201,162,39,0.06)" }}
      title="Independently tested by a third-party analytical laboratory. Research use only."
    >
      <svg viewBox="0 0 32 32" className={compact ? "w-5 h-5" : "w-6 h-6"} aria-hidden="true">
        <defs>
          <linearGradient id="bl-gold" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stopColor="#F5DE8A" />
            <stop offset="0.5" stopColor="#C9A227" />
            <stop offset="1" stopColor="#8A6D12" />
          </linearGradient>
        </defs>
        <path d="M16 1.5l3.2 2.6 4.1-.4 1.6 3.8 3.8 1.6-.4 4.1 2.6 3.2-2.6 3.2.4 4.1-3.8 1.6-1.6 3.8-4.1-.4L16 30.5l-3.2-2.6-4.1.4-1.6-3.8-3.8-1.6.4-4.1L1.1 16l2.6-3.2-.4-4.1 3.8-1.6 1.6-3.8 4.1.4z" fill="url(#bl-gold)" />
        <circle cx="16" cy="16" r="9.5" fill="#050A16" />
        <path d="M11 16.5l3.2 3.2L21.5 12.5" fill="none" stroke="url(#bl-gold)" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
      <div className="leading-none text-left">
        <div className={`font-mono uppercase tracking-[0.22em] text-[#F0D77A] ${compact ? "text-[8px]" : "text-[9px]"}`}>{LINE_1}</div>
        <div className={`font-mono uppercase tracking-[0.22em] text-white/75 mt-1 ${compact ? "text-[8px]" : "text-[9px]"}`}>{LINE_2}</div>
      </div>
    </div>
  );
}

export function DeliveryPromise({ className = "" }) {
  return (
    <div data-testid="delivery-promise" className={`inline-flex items-center gap-2 font-mono text-[10px] tracking-[0.2em] uppercase text-white/55 ${className}`}>
      <span className="w-1.5 h-1.5 rounded-full bg-[color:var(--bl-green)]" style={{ boxShadow: "0 0 8px var(--bl-green-soft)" }} />
      4–7 day delivery across Australia
    </div>
  );
}
